
export const formatNumDoc = ( value ) => {
  const cleanValue = value.replace(/(^0)|[^\d]/g, '');

  return cleanValue;
}
